// 動画セクションのモーダル

/**
 * 特定のIDを持つモーダルを検索する純粋関数。
 * @param {NodeListOf<Element>} modals - 検索対象のモーダル要素のリスト。
 * @param {string} id - 検索するモーダルのID。
 * @returns {Element|null} - 見つかったモーダル要素、またはnull。
 */
const findModalById = (modals, id) => modals.find((modal) => modal.getAttribute('data-movie-modal-id') === id);

/**
 * モーダルを表示する純粋関数。
 * @param {Element} modal - 表示するモーダル要素。
 */
const showModal = (modal) => {
  modal.classList.add('movie__modal--active');
  document.body.style.overflow = 'hidden';
};

/**
 * モーダルを非表示にする純粋関数。
 * @param {Element} modal - 非表示にするモーダル要素。
 */
const hideModal = (modal) => {
  modal.classList.remove('movie__modal--active');
  document.body.style.overflow = '';
  modal.querySelector('.movie__iframe').src = '';
};

/**
 * iframeにソースURLを設定する関数。
 * @param {Element} modal - ソースURLを設定するモーダル要素。
 */
const setIframeSrc = (modal) => {
  const iframeElement = modal.querySelector('iframe');
  if (!iframeElement) return;

  const src = iframeElement.getAttribute('data-src');
  if (!src) return;

  iframeElement.setAttribute('src', src);
};

/**
 * モーダル内のクリックイベントハンドラを設定する副作用のある関数。
 * @param {Element} modal - イベントハンドラを設定するモーダル要素。
 * @param {function} hideModalFunc - モーダルを非表示にする関数。
 */
const setupClickHandlers = (modal, hideModalFunc) => {
  modal.addEventListener('click', () => hideModalFunc(modal));

  const closeButton = modal.querySelector('.movie__modalCloseButton');
  closeButton.addEventListener('click', () => hideModalFunc(modal));

  const modalInner = modal.querySelector('.movie__modalInner');
  modalInner.addEventListener('click', (e) => e.stopPropagation());
};

/**
 * モーダル機能を初期化するメインロジック。
 * @param {NodeListOf<Element>} thumbnails - クリックイベントを設定するサムネイル要素のリスト。
 * @param {NodeListOf<Element>} modals - モーダル要素のリスト。
 */
export const initializeModalFunctionality = (thumbnails, modals) => {
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const movieId = thumbnail.getAttribute('data-movie-thumbnail-id');
      const modal = findModalById(Array.from(modals), movieId);

      if (modal) {
        showModal(modal);
        setupClickHandlers(modal, hideModal);
        setIframeSrc(modal);
      }
    });
  });
};
